import { Component, effect, inject, input, OnInit, ViewChild } from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button'
import { MatTableModule, MatRow, MatTableDataSource } from '@angular/material/table'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatCheckbox } from '@angular/material/checkbox'


import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NgFor, NgIf } from '@angular/common';
import { style, state, trigger, transition, animate } from '@angular/animations';
import { FeedstockService } from '../../../services/feedstockservice';
import { PriceMatrixList } from '../../../interfaces/pricematrixmodel';
import { FilterState } from '../../../interfaces/generatorsmodel';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { AddeditPricematrixComponent } from './addedit-pricematrix/addedit-pricematrix.component';
import { AttachDocumentsComponent } from '../../loadschedules/attach-documents/attach-documents.component';
import { ViewDocumentsComponent } from '../../loadschedules/view-documents/view-documents.component';
import { NotificationService } from '../../../services/notificationservice';
import { RolePermissionsService } from '../../../services/role-permissions.service';
import { LoadScheduleControlFlags, ScreenName } from '../../../interfaces/securityPermissions';
import { RoleService } from '../../../services/role.service';

@Component({
  selector: 'app-pricematrix',
  standalone: true,
  imports: [CommonModule,MatTableModule, MatRow, MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatButtonModule, MatSelectModule, MatDatepickerModule, DatePipe,
    MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule, MatCardModule, MatIconModule],
  templateUrl: './pricematrix.component.html',
  styleUrl: './pricematrix.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class PricematrixComponent implements OnInit{
  permissions = inject(RolePermissionsService);
  readonly BASE_COLUMNS: string[] = ['actions', 'id','tipFee', 'tipFee_UOMV', 'disposalSiteNames',
    'haulRate', 'monthly_Charges',
    'effective_StartDate','effective_EndDate','rebate_UOMName','rebateValue','eis',
    'fuelSurcharge','minimalCharges','emergency','noShow','financeFee',
    'selfHaulDescription','commissionEligibleDescription','haulFeePassThroughDescription','fuelSurchargePassThroughDescription',
    'invoiceNADescription', 'incurEstimatedProcessingCostsDescription', 'isReviewedDescription',
    'environmentalFee_LTL', 'environmentalFee_FTL', 'unloadingFee'];
  displayedColumns: string[] = [...this.BASE_COLUMNS];
  dataSource = new MatTableDataSource<any>;
  loadPMList: PriceMatrixList[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  filterState = input<FilterState | null>(null);
  refreshTrigger = input<number>(0);
  gridSearchText = input<string | null>(null);
  private _lastGenId: string = '__UNSET__';
  private _lastStreamId: string = '__UNSET__';
  private _lastTrigger: number = -1;
  showBinRentalFee: boolean = false;
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();
  
  constructor(private _dialog: MatDialog, private fsService: FeedstockService,
    private notificationService: NotificationService, private rolesService: RoleService
  ) {      
    effect(() => {
      const currentFilter = this.filterState();
      const trigger = this.refreshTrigger();

      if (!currentFilter || currentFilter.tabIndex !== 2) return;

      if(currentFilter?.isWalmart){
        if (!this.displayedColumns.includes('binRentalFee')) {
          this.displayedColumns = [...this.BASE_COLUMNS, 'binRentalFee'];
        }
        this.showBinRentalFee = true;
      }else{
        this.displayedColumns = [...this.BASE_COLUMNS];
        this.showBinRentalFee = false;
      }

      const genId = currentFilter?.generator?.toString() || '0';
      const streamId = currentFilter?.stream?.toString() || '0';

      const isForceRefresh = this._lastTrigger !== trigger;
      const hasFilterChanged = this._lastGenId !== genId || this._lastStreamId !== streamId;

      
      this._lastGenId = genId;
      this._lastStreamId = streamId;
      this._lastTrigger = trigger;

      
      if (genId === '0' || genId === 'null' || streamId === '0' || streamId === 'null') {
        this.dataSource.data = [];
        return;
      }

      if (!isForceRefresh && !hasFilterChanged) {
        return;
      }
      this.getPriceMatrixDetails(parseInt(genId), parseInt(streamId));
    });
    
    effect(() => {
      const searchText = this.gridSearchText();
      if (this.dataSource) { 
        console.log(`PM Component: Applying filter for search text: ${searchText}`);
        this.applyGridFilter(searchText ?? '');
      }
    });    
  }

  ngOnInit(): void {
    //this.getPriceMatrixDetails();
       
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.CustomerInfo, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
  }

  getPriceMatrixDetails(genid: number, streamid: number): void {
    if(streamid === 0){
      return;
    }
    this.fsService.getPriceMatrixList(genid, streamid).subscribe({
      next: (res: PriceMatrixList[]) => {
        console.log("pm data", res);
        this.loadPMList = res;
        this.dataSource = new MatTableDataSource(this.loadPMList);
        
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

        const currentSearchText = this.gridSearchText();
        if (currentSearchText) {
            this.applyGridFilter(currentSearchText);
        }
      }
    });
  }

  applyGridFilter(filterText: string) {
    console.log("PM grid search fired");
    const filterValue = filterText.trim().toLowerCase();
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onOpenPM(row: PriceMatrixList, task: string): void {    
    const genId = this.filterState()?.generator?.toString() || '0';
    this.fsService.getPriceMatrixById(row.id).subscribe({
      next: (res: PriceMatrixList) => {
        console.log("PM details on edit click ", res);
        var rowData = res;
        if(task == 'Duplicate'){
          rowData.id = 0;
          rowData.isReviewed = false;
          rowData.reviewedBy = null;
          rowData.reviewedDate = null;
        }
        const dialogRef = this._dialog.open(AddeditPricematrixComponent, {
          data: { 
            pmInputData: rowData,
            streamId: this.filterState()?.stream || 0,
            genId: parseInt(genId),
            task: task,
            canSave: this.controlPermissions.editPriceMatrix,
            showBinRentalFee: this.showBinRentalFee,
            showSalesRepAddButton: this.controlPermissions.addSalesRep,
            showSalesRepGridEditButton: this.controlPermissions.editSalesRep,
            showSalesRepGridDeleteButton: this.controlPermissions.deleteSalesRep
          },
          disableClose: true,
          width: '1000px',
          maxWidth: '1050px',
          maxHeight: '90vh'
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            const genId = this.filterState()?.generator?.toString() || '0';
            const streamid = this.filterState()?.stream?.toString() || '0';
            this.getPriceMatrixDetails(parseInt(genId), parseInt(streamid));
            this.notificationService.show(`Price Matrix saved successfully.`, 'Success');
          }
        });
      }
    });
    
  }

  onDeletePM(id: number){
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete Price Matrix ${id}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this._dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
        if (id !== null && id !== undefined) {
          const genId = this.filterState()?.generator?.toString() || '0';
          this.fsService.deletePriceMatrix(id).subscribe({
            next: () => {
              this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
              this.notificationService.show('Price Matrix deleted successfully.', 'Success');
            }
          });
        }
      }
    });
  }

  openAttachDocuments(id: number): void {
    const dialogRef = this._dialog.open(AttachDocumentsComponent, {
      // panelClass: 'attachDocumentsDialog',      
      disableClose: true,
      width: '700px',
      maxWidth: '700px',
      maxHeight: '90vh',
      data: {
        loadScheduleId: id,
        screenTypeId: '3',
        name: `${id}`
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.getLoadSchedules();
      }
    });
  }  
  openViewDocsDialog(id: number): void {
    this._dialog.open(ViewDocumentsComponent, {
      //panelClass: 'viewDocsDialog',
      disableClose: true,
      data: {
        loadScheduleId: id,
        screenTypeId: '3',
        canShowGridActions: this.controlPermissions.showDocumentDeleteButton,
        name: `${id}`
      }
    });
  }

  loadMenuDataAndOpen(row: PriceMatrixList, trigger: MatMenuTrigger): void {
    this.fsService.getLoadslipByPMId(row.id).subscribe({
      next: (data: boolean) => {
        row.loadSlip = data;
        trigger.openMenu();
      }
    });
  }

  private isNumeric(value: string): boolean {
    return value !== null && value.trim() !== '' && !isNaN(Number(value));
  }

  private isNumericFilterMatch(data: PriceMatrixList, filterValue: number): boolean {
    const numericFields: Array<keyof PriceMatrixList> = [
      'rental_Rate', 'haulRate', 'tipFee', 'tipFee_UOM', 'rebateValue', 'rebate_UOM',
      'eis', 'fuelSurcharge', 'extra_Pickup', 'monthly_Charges'
    ];    
    for (const field of numericFields) {
      const value = data[field];
      if (typeof value === 'number' && value === filterValue) {
        return true;
      }
    }
    return false;
  }
}
